<section class="ecommerce-view-body-wrapper">
  <div class="ecommerce-table-row heads"
       [ngStyle]="headerGreedStyle">
    <span *ngFor="let head of heads" [innerHTML]="head"></span>
  </div>
  <div class="list">
    <ng-content></ng-content>
  </div>
</section>


